import React from 'react';
import * as Styled from './style';

const HeroChatbot = () => {

  const handleScroll = () => {
    const formSection = document.getElementById('demo-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Styled.Section>
      <Styled.ContentWrapper>
        <div>
          <Styled.Heading>Plug the power of AI chat into your website</Styled.Heading>
          <Styled.Description>
            Our home services AI chatbot will greet your web visitors, tell them
            about your business, and help make sure they become customers. All
            without costing you a penny.
          </Styled.Description>

          <Styled.Button  onClick={handleScroll}>Get a demo</Styled.Button>

        </div>
      </Styled.ContentWrapper>
    </Styled.Section>
  );
};

export default HeroChatbot;
